import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import Button from 'material-ui/Button';

import RDayContainer from './DayContainer';
import ExtraWork from './ExtraWork';

import * as CalendarState from '../../../state/reducer/calendar/calendar';
import * as DesignerState from '../../../state/reducer/designer/designer';
import * as ClipboardState from '../../../state/reducer/clipboard/clipboard';
import * as CalendarCollapseState from '../../../state/reducer/calendarCollapse/calendarCollapse';
import * as AppState from '../../../state/reducer/app/appState';
import * as ToastState from '../../../state/reducer/clipboard/toast';
import FeatureFlag from '../../../v5/features/components/FeatureFlag';
import * as Utils from '../../../lib/designerUtils';
import * as ProgramTypes from '../../../state/reducer/calendar/programTypes';

import SegmentService, {
    EVENTS as SEGMENT_EVENTS
} from '../../../lib/segment/SegmentService';

import Console from '../../../lib/debug';
import NutritionCard from './NutritionCard';
import { FEATURES } from '../../../v5/features/components/constants';

class Day extends Component {
    getDesignerUrl = () => {
        let splitKey = Utils.splitDayKey(this.props.dayKey);
        return CalendarState.getDesignerUrl(
            null,
            splitKey.year,
            splitKey.month,
            splitKey.day,
            splitKey.weekIndex,
            splitKey.dayIndex
        );
    };

    getProgramId = () =>
        ProgramTypes.getAthleteValue(
            this.props.programType,
            this.props.athleteId,
            this.props.programId
        );

    hoverDay = () => {
        CalendarState.calendarDayHover(this.props.dayKey);
    };

    toggleLibraryDrawer = () => {
        CalendarState.selectDay(this.props.day);
        CalendarState.toggleSideNav(true);

        SegmentService.track(SEGMENT_EVENTS['ClickCTA'].key, {
            sources: 'Web app',
            ctaLocation: 'Day on calendar hover state',
            ctaText: 'Add From Library'
        });
    };

    async redirectToDesigner() {
        let day = this.props.day;

        if (!day.items.length) {
            ToastState.showLoadingMessage('Adding session...');
            await DesignerState.createSession(day);
        }

        let designerUrl = this.getDesignerUrl();
        AppState.navigate(designerUrl);
    }

    onClickCreateSession() {
        this.redirectToDesigner();

        SegmentService.track(SEGMENT_EVENTS['ClickCTA'].key, {
            sources: 'Web app',
            ctaLocation: 'Day on calendar hover state',
            ctaText: 'Create Session'
        });
    }

    onClickEditSession() {
        this.redirectToDesigner();

        SegmentService.track(SEGMENT_EVENTS['ClickCTA'].key, {
            sources: 'Web app',
            ctaLocation:
                'Day on calendar hover state when there is a session planned',
            ctaText: 'Edit'
        });
    }

    render() {
        Console.render('Day');
        const {
            day,
            dayHeaders,
            dayIndex,
            weekIndex,
            dayKey,
            isHovering,
            programType
        } = this.props;
        let style = {};
        let className = 'day noselect';
        let programId = this.getProgramId();
        let isCollapsed = false;
        let dayHeader;
        let collapseKey;
        if (programId) {
            collapseKey = CalendarCollapseState.getKey(programType, programId);
            dayHeader = dayHeaders[collapseKey][dayIndex];
            isCollapsed = dayHeader.status;
        }
        let extraWork = null;
        let nutrition = null;

        if (isCollapsed) {
            style.maxWidth = '60px';
            style.minWidth = '60px';
            style.width = '60px';
            className += ' collapsed';
        } else if (dayHeader) {
            let width = CalendarCollapseState.getExpandedWidth(collapseKey);
            style.maxWidth = width;
            style.minWidth = width;
            style.width = width;
        } else {
            style.maxWidth = 'auto';
        }

        let monthTitle = null;

        if (day.day === 1) {
            let monthName = Utils.getMonthTitle(day.month);
            monthName = isCollapsed ? monthName.substr(0, 3) : monthName;
            monthTitle = <span className="month">{monthName}&nbsp;&nbsp;</span>;
        } else if (day.timelineDay === 1 || (day.timelineDay - 1) % 7 === 0) {
            monthTitle = <span className="month">Week {weekIndex + 1}</span>;
        }

        const todayDay = moment().date();
        const todayMonth = moment().month() + 1;
        const todayYear = moment().year();

        const isToday =
            day.day === todayDay &&
            day.month === todayMonth &&
            day.year === todayYear;

        let dayHeaderClass = 'cal-day-header';
        if (isToday) {
            dayHeaderClass += ' is-today';
        }

        const isBeforeToday = moment().isAfter(day.date);
        if (isBeforeToday) {
            dayHeaderClass += ' is-before-today';
        }

        if (day.timelineDay === null && !day.currentMonth) {
            className += ' isPast';
        }

        if (isHovering) {
            className += ' day-hovering';
        }

        let editButton = null;

        if (day.items.length > 0) {
            editButton = (
                <Button
                    fullWidth={true}
                    icon={<i className="plus mdi mdi-plus" />}
                    className="blue"
                    onClick={this.onClickEditSession.bind(this)}
                >
                    EDIT
                </Button>
            );
        } else {
            editButton = (
                <Button
                    fullWidth={true}
                    icon={<i className="plus mdi mdi-plus" />}
                    className="blue"
                    onClick={this.onClickCreateSession.bind(this)}
                >
                    CREATE&nbsp;SESSION
                </Button>
            );
        }

        if (ProgramTypes.isCoachAthleteCalendar(this.props.programType)) {
            extraWork = <ExtraWork dayKey={dayKey} />;
            nutrition = <NutritionCard dayKey={dayKey} />;
        }

        const classes = 'add-workout layout-align-center-center layout-column';
        return (
            <div
                className={className}
                style={style}
                onMouseEnter={this.hoverDay}
                onMouseDown={this.hoverDay}
                id={this.props.dayKey}
                role="button"
                tabIndex={0}
                onContextMenu={ClipboardState.selectFromRightClick}
            >
                <div className={dayHeaderClass}>
                    <div id={`_${day.day}`}>
                        {monthTitle}
                        <span className="day-num">{day.day}</span>
                    </div>
                </div>
                <FeatureFlag
                    feature={FEATURES.WEB_COACH_SHOW_NUTRITION_ON_CALENDAR_V1}
                >
                    {nutrition}
                </FeatureFlag>
                <RDayContainer
                    dayKey={dayKey}
                    weekIndex={weekIndex}
                    dayIndex={dayIndex}
                />
                {extraWork}
                <div className="combo-add-area layout-row">
                    <div className={classes}>
                        {editButton}
                        <Button
                            fullWidth={true}
                            icon={<i className="plus mdi mdi-plus" />}
                            className="blue"
                            onClick={this.toggleLibraryDrawer.bind(this)}
                        >
                            Add&nbsp;From Library
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        day: state.calendar.dayTree[ownProps.dayKey],
        dayHeaders: state.calendarCollapse.calendarCollapseConfig,
        programType: state.calendar.infoTree.programType,
        programId: state.calendar.infoTree.programId,
        athleteId: state.calendar.infoTree.athleteId,
        ...ownProps
    };
};

export default connect(mapStateToProps)(Day);
